<script setup lang="ts">
import { InputField } from '@caks/uikit/input'
import { IconSend, IconAttach } from '@caks/uikit/icon'
import { postChatMessage, postMedia } from '@caks/shared/api/user.route'

interface Props {
  desktop?: boolean
}

interface Emit {
  (emit: 'send', onSend: boolean): void
}

const message = ref('')
const media = ref('')
const emit = defineEmits<Emit>()
withDefaults(defineProps<Props>(), { desktop: false })

const sendMessage = async () => {
  try {
    const res = await postChatMessage(message.value, media.value)
    if (res.status === 'ERR') throw res.message
    message.value = ''
    media.value = ''
    emit('send', true)
  } catch (error) {}
}

const onInputFIle = async (event: Event) => {
  const target = event.target as HTMLInputElement

  if (target.files) {
    const { data, status } = await postMedia(target.files[0])

    if (status === 'OK') {
      media.value = data[0]
    }
  }
}
</script>

<template>
  <form class="send" :class="{ send_desktop: desktop }" @submit.prevent="sendMessage">
    <div>
      <button type="button" class="send__attach">
        <icon-attach />
        <input type="file" @input="onInputFIle" />
        <div v-if="media" class="attach-marker">1</div>
      </button>
      <input-field v-model="message" placeholder="Введите сообщение..." />
      <button type="submit">
        <icon-send />
      </button>
    </div>
  </form>
</template>

<style scoped lang="scss">
.send {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 4px 12px;
  background-color: $bg-gray;

  padding-bottom: calc(4px + $safe-area-bottom);

  .chat_desktop & {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
  }

  &__attach {
    position: relative;

    input {
      position: absolute;
      inset: 0;
      opacity: 0;
    }

    .attach-marker {
      background-color: $primary-green;
      width: 16px;
      height: 16px;
      border-radius: 50%;

      position: absolute;
      top: -8px;
      right: -8px;

      display: flex;
      align-items: center;
      justify-content: center;

      color: white;
      @include h6-5;
    }
  }

  &_desktop {
    border-bottom-right-radius: 20px;
    border-bottom-left-radius: 20px;
    padding: 16px;
  }

  div {
    display: flex;
    align-items: center;
    gap: 12px;
    width: 100%;
  }

  button {
    width: 24px;
    height: 24px;
    --svg-col: #008443;

    position: relative;
    &:before {
      content: '';
      position: absolute;
      top: -12px;
      right: -12px;
      bottom: -12px;
      left: -12px;
      cursor: pointer;
    }
  }
}
</style>
